import React from 'react';

import './BreakLine.css';

export const BreakLine = () => {
  return <hr className='breakLine' />;
};
